exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".quotes-list{margin:0;padding:0;list-style:none}.quotes-list__quote{padding-top:0;padding-bottom:0}.quotes-list__quote__text{margin-bottom:5px;font-size:1.6rem}.quotes-list__quote__text:before{content:\"\\201C\"}.quotes-list__quote__text:after{content:\"\\201D\"}.quotes-list__quote__footer{font-size:1.3rem;font-style:italic}.quotes-list__quote__footer>span{padding-left:10px}.quotes-list__quote__footer>span:not(:first-child){position:relative;padding-left:5px}.quotes-list__quote__footer>span:not(:first-child):before{position:relative;left:-4px;content:\";\"}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./src/components/quotes-list/quotes-list.styl
// module id = 512
// module chunks = 0